// src/pages/partner/PartnerDashboard.js
import { useAuth } from "../login/AuthProvider";

function PartnerDashboard() {
  const { name, account, partner_id } = useAuth();

  return (
    <div className="container mt-4">
      <h3 className="mb-3">合作夥伴後台</h3>
      <p>合作夥伴 ID：{partner_id}</p>
      <p>合作夥伴名稱：{name || account}</p>

      <p className="text-muted mt-4">
        （之後會在這裡顯示：使用你專屬優惠碼報名的學員數量與列表）
      </p>
    </div>
  );
}

export default PartnerDashboard;
